class TruckDriver {
  constructor(
    id,
    name,
    phone,
    email,
    cpfCnpj,
    birthDate,
    visibleEquipment,
    equipments,
  ) {
    this.id = id
    this.name = name
    this.phone = phone
    this.email = email
    this.cpfCnpj = cpfCnpj
    this.birthDate = birthDate
    this.visibleEquipment = visibleEquipment
    this.equipments - equipments
  }
}

export const truckDriverDefault = () => {
  const truckDriver = {
    id: 0,
    name: "",
    phone: "",
    email: "",
    cpfCnpj: "",
    birthDate: "",
    visibleEquipment: null,
    equipments: []
  }
  return truckDriver
}

export default TruckDriver
